import { atom, selectorFamily } from 'recoil';
import { Accessory, AccessoryPack, Breadcrumb } from '~/common/models';
import { getAccessoryByPimId } from '~/common/services/accessories-service';

interface ModelAccessoriesMainPage {
  heading: string;
  subHeading: string;
  parentUrlSegment: string;
  accessoryPackTitleOverride?: string;
  pimIdentifier: string;
  modelName: string;
  modelBadgeUrl: string;
  accessory?: Accessory;
  accessoryPack?: AccessoryPack;
  relatedAccessoryPacks?: AccessoryPack[];
  breadcrumbs: Breadcrumb[];
  routeModelName: string;
  marketingCategoryOrder?: string[];
  showAccessoryGrouping?: boolean;
}

export const ModelAccessoriesPage = atom<ModelAccessoriesMainPage>({
  key: 'ModelAccessoriesPage',
  default: {
    heading: '',
    subHeading: '',
    parentUrlSegment: '',
    pimIdentifier: '',
    modelName: '',
    modelBadgeUrl: '',
    breadcrumbs: [],
    routeModelName: '',
    relatedAccessoryPacks: [],
    marketingCategoryOrder: [],
    showAccessoryGrouping: false,
  },
});

export const ModelAccessories = atom<Accessory[]>({
  key: 'ModelAccessories',
  default: [],
});

export const ModelAccessoryPacks = atom<AccessoryPack[]>({
  key: 'ModelAccessoryPacks',
  default: [],
});

export const ModelAccessoryPacksQuery = selectorFamily<
  AccessoryPack[],
  TModelAccessoriesQuery
>({
  key: 'ModelAccessoryPacksQuery',
  get: (props) => async () => {
    const res = await fetch(
      `/api/accessories/accessory-packs/model/${
        props.pimId
      }?groupByVariantMarketingCategory=${!!props.showAccessoryGrouping}`
    );
    return (await res.json()) as AccessoryPack[];
  },
});

type TModelAccessoriesQuery = {
  pimId: string;
  showAccessoryGrouping?: boolean;
};

export const ModelAccessoriesQuery = selectorFamily<
  Accessory[],
  TModelAccessoriesQuery
>({
  key: 'ModelAccessoriesQuery',
  get: (props: TModelAccessoriesQuery) => async () => {
    const res = await fetch(
      `/api/accessories/accessories/model/${
        props.pimId
      }?groupByVariantMarketingCategory=${!!props.showAccessoryGrouping}`
    );
    return (await res.json()) as Accessory[];
  },
});

export const TopAccessoriesQuery = selectorFamily<Accessory[], string[]>({
  key: 'TopAccessoriesQuery',
  get: (pimIds: string[]) => async () => {
    const accessoriesPromise: Promise<Accessory>[] = [];

    pimIds.forEach((pimId) => {
      if (!!pimId) {
        accessoriesPromise.push(getAccessoryByPimId(pimId));
      }
    });

    return await Promise.all(accessoriesPromise);
  },
});

export const ModelAccessoryActiveRoute = atom<string>({
  key: 'ModelAccessoryActiveRoute',
  default: '',
});

export const AccessoryRouteBreadcrumbs = atom<Breadcrumb[]>({
  key: 'AccessoryRouteBreadcrumbs',
  default: [],
});
